import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30291558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-sm ml-s2" }

import NumberIcon from '@/components/icon/NumberIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTitle',
  props: {
    number: null,
    title: null,
    disabled: { type: Boolean },
    isActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex", { 'opacity-50': __props.disabled }])
  }, [
    _createVNode(NumberIcon, {
      number: __props.number,
      class: _normalizeClass(["text-primary text-xs", { pulse: __props.isActive }]),
      size: "24"
    }, null, 8, ["number", "class"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1)
  ], 2))
}
}

})